import type { FC, PropsWithChildren } from 'react'
import type { SxProps } from '@mui/material'
import { Box, CircularProgress, Stack } from '@mui/material'

type PlayerPlaceholderProps = PropsWithChildren & {
  aspectRatio?: string
  isLoading?: boolean
  'data-testid'?: string
}

const placeholderVideoStyles: SxProps = {
  width: 'auto',
  maxWidth: '100%',
  flex: 1,
  display: 'none',
  minHeight: 0,
  backgroundColor: 'var(--neutral-black)',
  ':first-of-type': { display: 'block' }
}

export const PlayerPlaceholder: FC<PlayerPlaceholderProps> = ({
  children,
  aspectRatio = '16/9',
  isLoading = false,
  'data-testid': dataTestId = 'player-placeholder'
}) => {
  return (
    <Box data-testid={dataTestId} sx={{ ...placeholderVideoStyles, aspectRatio }}>
      {isLoading ? (
        <Stack data-testid="player-placeholder-loading-spinner" justifyContent="center" alignItems="center" height="100%">
          <CircularProgress />
        </Stack>
      ) : (
        children
      )}
    </Box>
  )
}

PlayerPlaceholder.displayName = 'PlayerPlaceholder'
